<template>
  <textarea
    class="textarea"
    :placeholder="placeholder"
    type="text"
    @input="updateValue"
  />
</template>

<script setup>
const props = defineProps({
  placeholder: {
    type: String,
    required: false,
  },
  modelValue: String,
})

const emit = defineEmits(["update:modelValue"])
const updateValue = (event) => {
  emit("update:modelValue", event.target.value)
}
</script>

<style lang="scss" scoped>
.textarea {
  width: 100%;
  height: 140px;
  background: $white;
  border-radius: 6px;
  padding: 32px;
  resize: none;
  border: none;
  outline: none;
  font-size: 12px;
  @media screen and (max-width: 460px) {
    font-size: 16px;
  }
  @include sm {
    height: 100px;
    padding: 16px 20px;
  }
}
</style>
